const actions = {
  SET_STATE: 'peakequivalence/SET_STATE',
  LOAD_DATA: 'peakequivalence/LOAD_DATA',
  START_ASSESSMENT: 'peakequivalence/START_ASSESSMENT',
  RECORD_RESPONSE: 'peakequivalence/RECORD_RESPONSE',
  GET_REPORT: 'peakequivalence/GET_REPORT',
  FINISH_ASSESSMENT: 'peakequivalence/FINISH_ASSESSMENT',
}

export default actions
